import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  foyerThingsData: [],
  foyerThingsLoader: true,
  foyerThingsError: "",
};

const getEndpoint = (roomName, location) => {
const loc = localStorage.getItem('userLocation');
   const prefix = loc === 'kkt' ? 'kkt' : '';
  // const prefix = localStorage.getItem('userLocation');
  const db = localStorage.getItem('projectDatabase') || '(default)'; // fallback for safety
  // return `https://us-central1-fabdiz-quote.cloudfunctions.net/api/rooms/${prefix}${roomName}`;
  return `https://us-central1-fabdiz-quote.cloudfunctions.net/api/rooms/${prefix}${roomName}/${db}`;
};

export const fetchFoyerThingsList = createAsyncThunk(
  'fetchfoyerThings',
  async ({  } = {}, { rejectWithValue }) => {
    try {
      const url = getEndpoint('Foyer');
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch foyer data');
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const foyerReducer = createSlice({
  name: 'foyerThings',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchFoyerThingsList.fulfilled]: (state, action) => {
      state.foyerThingsData = action.payload;
      state.foyerThingsLoader = false;
      state.foyerThingsError = "";
    },
    [fetchFoyerThingsList.pending]: (state) => {
      state.foyerThingsLoader = true;
      state.foyerThingsError = "";
    },
    [fetchFoyerThingsList.rejected]: (state, action) => {
      state.foyerThingsLoader = false;
      state.foyerThingsError = action.payload ?? "refresh the page";
    },
  },
});

export default foyerReducer.reducer;